<template>
  <div class="general-meeting-detail">
    <el-form label-width="80px">
      <el-form-item label="会议类型">
        <el-input value="综合议题会议" readonly></el-input>
      </el-form-item>
      <el-form-item label="会议主题">
        <el-input :value="detailData.title" readonly></el-input>
      </el-form-item>
      <el-form-item label="会议状态">
        <el-input :value="getStatusLabel()" readonly></el-input>
      </el-form-item>
    </el-form>
    <el-tabs v-model="activeName">
      <!-- -----------------------------议程列表---------------------------------------- -->
      <el-tab-pane label="议程列表" name="first">
        <el-table
          :data="scheduleData"
          border
          style="width: 100%; margin-top: 10px"
          :cell-class-name="cellClassHandler"
        >
          <el-table-column
            type="index"
            width="50"
            label="序号"
          ></el-table-column>
          <el-table-column
            prop="title"
            label="议程"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="议题" show-overflow-tooltip>
            <template slot-scope="scope">
              <p
                class="topic-item"
                v-for="(item, index) in scope.row.declarationList"
                :key="index"
              >
                {{ item.title }}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="汇报人" show-overflow-tooltip>
            <template slot-scope="scope">
              <p style="padding: 0 6px">
                <span
                  class="reporter-item"
                  v-for="(item, index) in handleReporter(scope.row)"
                  :key="index"
                >
                  {{ item }}
                </span>
              </p>
            </template>
          </el-table-column>
          <el-table-column label="参会部门" show-overflow-tooltip>
            <template slot-scope="scope">
              <span
                class="reporter-item"
                v-for="(item, index) in handleCheckWork(scope.row)"
                :key="index"
              >
                {{ item }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="会议类别" show-overflow-tooltip width="450">
            <template slot-scope="scope">
              <el-checkbox-group :value="handleTypeMap(scope.row)">
                <el-checkbox
                  v-for="(item, index) in handleAllTypeMap(scope.row)"
                  :key="index"
                  :label="item"
                ></el-checkbox>
              </el-checkbox-group>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="createFile(scope.row)"
                >生成汇报材料</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center; margin-top: 20px">
          <el-button type="info" @click.stop="closePage">关闭</el-button>
        </div>
      </el-tab-pane>
      <!-- --------------------------------------会议安排---------------------------------------------------- -->
      <el-tab-pane label="会议安排" name="second">
        <div
          class="arrange-box"
          v-for="(item, index) in arrangeData"
          :key="index"
        >
          <el-form label-width="100px">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="会议类别：">
                  <el-input :value="item.typeDisplayName" readonly></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="打印文件标题">
                  <el-input :value="item.printTitle" readonly></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="会议时间：">
                  <el-input
                    :value="handleTime(item.startTime)"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="会议次数">
                  <el-input :value="item.conferNum" readonly></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="会议地点：">
              <el-input :value="item.room" readonly></el-input>
            </el-form-item>
            <el-form-item label="出席人员：">
              <div class="el-input tag-wrapper">
                <el-tag
                  v-for="tag in handleJoinWork(item, 1)"
                  :key="tag.id"
                  style="margin-right: 5px"
                  >{{ tag.displayName || tag.name }}</el-tag
                >
              </div>
            </el-form-item>
            <el-form-item label="列席人员">
              <el-input :value="item.attendWorkName" readonly></el-input>
            </el-form-item>
            <el-form-item label="抄送人员：">
              <div class="el-input tag-wrapper">
                <el-tag
                  v-for="tag in handleJoinWork(item, 2)"
                  :key="tag.id"
                  style="margin-right: 5px"
                  >{{ tag.displayName || tag.name }}</el-tag
                >
              </div>
            </el-form-item>
          </el-form>
          <el-table
            :data="item.agendaList"
            border
            :cell-class-name="arrangeCellClassHandler"
          >
            <el-table-column
              type="index"
              width="50"
              label="序号"
            ></el-table-column>
            <el-table-column
              prop="title"
              label="议程"
              show-overflow-tooltip
              min-width="200px"
            >
              <template slot-scope="scope">
                <p style="overflow: hidden; text-overflow: ellipsis">
                  <span
                    v-for="(tStr, index) in splitStr(scope.row)"
                    :key="index"
                  >
                    {{ tStr }}
                  </span>
                </p>
              </template>
            </el-table-column>
            <el-table-column
              label="议题"
              show-overflow-tooltip
              min-width="200px"
            >
              <template slot-scope="scope">
                <p
                  class="topic-item"
                  v-for="(item, index) in filterDeclarationList(scope.row)"
                  :key="index"
                >
                  {{ item.title }}
                </p>
              </template>
            </el-table-column>
            <el-table-column label="汇报人" show-overflow-tooltip>
              <template slot-scope="scope">
                <p style="overflow: hidden; text-overflow: ellipsis">
                  <span
                    class="reporter-item"
                    v-for="(item, index) in handleReporter(scope.row)"
                    :key="index"
                  >
                    {{ item }}
                  </span>
                </p>
              </template>
            </el-table-column>
            <el-table-column label="参会部门" show-overflow-tooltip>
              <template slot-scope="scope">
                <span
                  class="reporter-item"
                  v-for="(item, index) in handleCheckWork(scope.row)"
                  :key="index"
                >
                  {{ item }}
                </span>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 20px; text-align: center">
            <el-button type="primary" @click="printArrangement(item)"
              >打印安排</el-button
            >
            <el-button
              type="info"
              @click.stop="closePage"
              v-if="index == arrangeData.length - 1"
              >关闭</el-button
            >
          </div>
        </div>
      </el-tab-pane>
      <!-- ------------------------------会议纪要------------------------------------------- -->
      <el-tab-pane
        label="会议纪要"
        name="third"
        v-if="minutesVisible"
        style="padding-bottom: 50px"
      >
        <div style="margin: 20px 0">
          <!-- 4-上传完纪要， 5-会议结束了 -->
          <el-button
            type="primary"
            @click="upMeetingMinutes"
            :disabled="detailData && detailData.status >= 4"
            >开始上传会议纪要</el-button
          >
        </div>
        <div v-if="inUpMeetingMinutes">
          <!-- 上传会议纪要 -->
          <!-- 上传会议纪要 -->
          <!-- 上传会议纪要 -->
          <p style="margin: 10px 0">总体纪要：</p>
          <el-input
            type="textarea"
            clearable
            :autosize="{ minRows: 12 }"
            placeholder="-请输入-"
            show-word-limit
            maxlength="20000"
            v-model="meetingMinutesGeneralSummary"
          ></el-input>
          <p style="margin: 10px 0">议题纪要：</p>
          <el-table :data="upMeetingMinutesData" border>
            <el-table-column
              type="index"
              width="50"
              label="序号"
            ></el-table-column>
            <!-- <el-table-column prop="id" label="ID"></el-table-column> -->
            <el-table-column
              prop="title"
              label="主题"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="议题" show-overflow-tooltip>
              <template slot-scope="scope">
                <p
                  v-for="(item, index) in scope.row.declarationList"
                  :key="index"
                >
                  {{ item.title }}
                </p>
              </template>
            </el-table-column>
            <el-table-column label="会议纪要" show-overflow-tooltip>
              <template slot-scope="scope">
                <div
                  v-for="(item, index) in scope.row.declarationList"
                  :key="index"
                >
                  <el-input
                    v-model="item.minutes"
                    placeholder="-请输入-"
                  ></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="负责人" show-overflow-tooltip>
              <template slot-scope="scope">
                <div
                  v-for="(item, index) in scope.row.declarationList"
                  :key="index"
                >
                  <span>
                    <i
                      class="el-icon-circle-plus"
                      @click="addHeadPeople(item)"
                    ></i>
                  </span>
                  <span v-for="user in item.headPeople" :key="user.id">
                    {{ user.displayName || user.name }}&nbsp;
                  </span>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: center; padding: 20px 0">
            <el-button type="primary" @click="saveMeetingMinutes"
              >保存</el-button
            >
            <el-button type="info" @click="cancelJiyao">取消</el-button>
            <el-button type="info" @click.stop="closePage">关闭</el-button>
          </div>
        </div>
        <!-- 只是展示数据，有啥展示啥 -->
        <div v-else>
          <p style="margin: 10px 0">总体纪要：</p>
          <el-input
            type="textarea"
            clearable
            :autosize="{ minRows: 12 }"
            placeholder="-请输入-"
            show-word-limit
            maxlength="20000"
            v-model="detailData.generalSummary"
            :readonly="true"
          ></el-input>
          <p style="margin: 10px 0">议题纪要：</p>
          <el-table
            :data="scheduleData"
            border
            :cell-class-name="cellClassHandler2"
          >
            <el-table-column
              type="index"
              width="50"
              label="序号"
            ></el-table-column>
            <!-- <el-table-column prop="id" label="ID"></el-table-column> -->
            <el-table-column
              prop="title"
              label="主题"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="议题" show-overflow-tooltip>
              <template slot-scope="scope">
                <p
                  class="topic-item"
                  v-for="(item, index) in scope.row.declarationList"
                  :key="index"
                >
                  {{ item.title }}
                </p>
              </template>
            </el-table-column>
            <el-table-column label="会议纪要" show-overflow-tooltip>
              <template slot-scope="scope">
                <div
                  class="topic-item"
                  v-for="(item, index) in scope.row.declarationList"
                  :key="index"
                >
                  <p>
                    <span v-if="item.summary">{{ item.summary }}</span>
                    <span v-else>&nbsp;</span>
                  </p>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="负责人" show-overflow-tooltip>
              <template slot-scope="scope">
                <div
                  class="outter-box"
                  v-for="(item, index) in scope.row.declarationList"
                  :key="index"
                >
                  {{ findChargePeople(item) }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>

      <!-- 会议反馈 -->
      <el-tab-pane
        label="会议反馈"
        name="fourth"
        v-if="minutesVisible"
        style="padding-bottom: 50px"
      >
        <div style="margin: 20px 0">
          <!-- 4上传完纪要了，5就是会议结束了。所以要为4时才有可能上传 -->
          <!-- <input type="text" :value="detailData.status"> -->
          <el-button
            type="primary"
            @click="upMeetingFeedback"
            :disabled="!(detailData && detailData.status == 4)"
            >开始上传会议反馈</el-button
          >
          <span style="color: rgba(255, 0, 0, 0.6)"
            >请确保每条反馈都已经通过右侧按钮保存</span
          >
        </div>
        <!-- <div>inUpMeetingFeedback: {{inUpMeetingFeedback}}</div> -->
        <div v-if="inUpMeetingFeedback">
          <!-- 上传会议反馈 -->
          <!-- 上传会议反馈 -->
          <!-- 上传会议反馈 -->
          <p style="margin: 10px 0">总体纪要：</p>
          <el-input
            type="textarea"
            clearable
            :autosize="{ minRows: 12 }"
            placeholder="-请输入-"
            show-word-limit
            maxlength="20000"
            v-model="detailData.generalSummary"
            :readonly="true"
          ></el-input>
          <p style="margin: 10px 0">议题纪要：</p>
          <el-table :data="feedbackDataLocal" border>
            <el-table-column
              type="index"
              width="50"
              label="序号"
            ></el-table-column>
            <el-table-column
              prop="title"
              label="主题"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="议题" show-overflow-tooltip>
              <template slot-scope="scope">
                <p v-for="(item, index) in scope.row.list" :key="index">
                  {{ item.title }}
                </p>
              </template>
            </el-table-column>
            <el-table-column label="会议纪要" show-overflow-tooltip>
              <template slot-scope="scope">
                <div v-for="(item, index) in scope.row.list" :key="index">
                  <p>
                    {{ item.summary }}
                  </p>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="会议反馈 (填写完后需单独保存)" width="450">
              <template slot-scope="scope">
                <div v-for="(item, index) in scope.row.list" :key="index">
                  <div v-for="user in item.list" :key="user.id">
                    <!-- 如果已经提交了，只能看看 -->
                    <p v-if="user.feedback">
                      {{ user.feedback }}
                    </p>
                    <!-- 还没提交 -->
                    <!-- 我还没提交的，才能写反馈 -->
                    <div
                      v-else-if="
                        user.writeUserIdSet &&
                        user.writeUserIdSet.indexOf(userId) != -1 &&
                        user.feedbackStatus == 0
                      "
                    >
                      <el-input
                        v-model="user.feedbackLocal"
                        placeholder="-请输入-"
                      >
                        <template slot="append">
                          <span
                            @click.stop="saveMeetingFeedback(user)"
                            title="保存"
                          >
                            <i class="el-icon-upload2"></i>
                          </span>
                        </template>
                      </el-input>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="负责人" show-overflow-tooltip>
              <template slot-scope="scope">
                <div
                  class="outter-box"
                  v-for="(item, index) in scope.row.list"
                  :key="index"
                >
                  <p class="inner-box" v-for="user in item.list" :key="user.id">
                    {{ user.reportUserName }}
                  </p>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: center; padding: 20px 0">
            <el-button type="primary" @click="stopMeetingFeedback"
              >完成</el-button
            >
            <el-button type="info" @click="cancalFankui">取消</el-button>
            <el-button type="info" @click.stop="closePage">关闭</el-button>
          </div>
        </div>

        <!-- 只是展示数据，有啥展示啥 -->
        <div v-else>
          <p style="margin: 10px 0">总体纪要：</p>
          <el-input
            type="textarea"
            clearable
            :autosize="{ minRows: 12 }"
            placeholder="-请输入-"
            show-word-limit
            maxlength="20000"
            v-model="detailData.generalSummary"
            :readonly="true"
          ></el-input>
          <p style="margin: 10px 0">议题纪要：</p>
          <el-table
            :data="feedbackData"
            border
            :cell-class-name="cellClassHandler2"
          >
            <el-table-column
              type="index"
              width="50"
              label="序号"
            ></el-table-column>
            <el-table-column
              prop="title"
              label="主题"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="议题" show-overflow-tooltip>
              <template slot-scope="scope">
                <p
                  class="topic-item"
                  v-for="(item, index) in scope.row.list"
                  :key="index"
                >
                  {{ item.title }}
                </p>
              </template>
            </el-table-column>
            <el-table-column label="会议纪要" show-overflow-tooltip>
              <template slot-scope="scope">
                <div
                  class="topic-item"
                  v-for="(item, index) in scope.row.list"
                  :key="index"
                >
                  <p>
                    {{ item.summary }}
                  </p>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="会议反馈" show-overflow-tooltip>
              <template slot-scope="scope">
                <div
                  v-for="(item, index) in scope.row.list"
                  :key="index"
                  class="outter-box"
                >
                  <p class="inner-box" v-for="user in item.list" :key="user.id">
                    {{ user.feedback ? user.feedback : "---" }}
                  </p>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="负责人" show-overflow-tooltip>
              <template slot-scope="scope">
                <div
                  class="outter-box"
                  v-for="(item, index) in scope.row.list"
                  :key="index"
                >
                  <p class="inner-box" v-for="user in item.list" :key="user.id">
                    {{ user.reportUserName }}
                  </p>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
    <select-dialog
      :visible="selectDialogVisible"
      @close="selectDialogClose"
      title="选择负责人"
      v-bind="selectDialogOptions"
    />
    <el-dialog title="会议材料" :visible.sync="textDialogVisible">
      <div :id="editorId"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="textDialogVisible = false" type="info"
          >关闭</el-button
        >
        <el-button type="primary" @click="printFile">打印</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="打印会议安排"
      :visible.sync="printArrageVisible"
      width="900px"
    >
      <ArrangeTable :detail="printArrangeDetail" />
      <!-- <div slot="footer">
        <el-button type="info" @click="printArrageVisible = false"
          >关闭</el-button
        >
        <el-button type="primary" @click="doPrintArrangement">打印</el-button>
      </div> -->
    </el-dialog>
    <iframe
      name="print_frame"
      width="0"
      height="0"
      frameborder="0"
      src="about:blank"
    ></iframe>
  </div>
</template>

<script>
// import $ from "jquery";
// window.$ = require("jquery");
// window.JQuery = require("jquery");
// require("../plugin/jquery.PrintArea.js");
// require('../plugin/printThis');
// require('../plugin/jquery.print');
import SelectDialog from "@/page/meeting/bill/SelectDialog";
import cloneDeep from "lodash/cloneDeep";
import { testData } from "./test";
import { editorConfig } from "../editorConfig";
import { getDeclarationDetail } from "@/services/declarationServices";
import { goBackApprove } from "@/page/approveComponents/approve";
import {
  getConferenceDetail,
  postConferenceSummary,
  postConferenceFeedback,
  getOtherConferenceTypeList,
} from "@/services/conferenceServices";
import Constants from "@/utils/consts";
import ArrangeTable from "./ArrangeTable";
import { formatTimeStr } from "@/utils/index";
export default {
  name: "GeneralMeetingDetail",
  components: {
    SelectDialog,
    ArrangeTable,
  },
  beforeDestroy() {
    if (this.editor) {
      this.editor.dispose();
    }
  },
  data() {
    return {
      printArrangeDetail: {},
      printArrageVisible: false,
      editorId: "general-meeting-detail-editor-container" + Date.now(),
      myEditor: undefined,
      editorConfig,
      textDialogVisible: false,
      testData,
      id: undefined,
      activeName: "first",
      detailData: {},
      scheduleData: [], // 会议议程列表数据
      arrangeData: [], // 会议安排数据
      feedbackData: [], // 纪要反馈列表
      generalSummaryReadonly: true,
      inUpMeetingMinutes: false,
      inUpMeetingFeedback: false,
      meetingMinutesGeneralSummary: "",
      upMeetingMinutesData: [],
      selectDialogVisible: false,
      writeUserIdSet: [], //可以点击会议反馈的人
      selectDialogOptions: {
        //负责人选择配置
        departOn: true,
        groupOn: false,
        canSelectDepart: false,
        canSelectUser: true,
        canSelectGroup: false,
        maxSelectedItem: 0,
        dataKey: "",
      },
      feedbackDataLocal: [],
      userId: undefined,
      typeList: [],
    };
  },
  methods: {
    closePage() {
      if (this.tabRouteParam.approveFlag) {
        goBackApprove(this.tabRouteParam.approveFlag, "generalMeetingDetail");
      } else {
        this.bus.$emit("tabClose", "generalMeetingDetail");
        this.bus.$emit("navMenuChange", {
          routeId: "general-meeting",
        });
      }
    },
    splitStr(row) {
      let str = row ? row.title : "";
      let result = [];
      while (str.indexOf(",") != -1) {
        let index = str.indexOf(",");
        let part = str.substring(0, index);
        if (part) {
          result.push(part);
        }

        if (index + 1 < str.length) {
          str = str.substring(index + 1, str.length);
        } else {
          str = "";
        }
      }
      if (str.length > 0) {
        result.push(str);
      }
      return result;
    },
    filterDeclarationList(row) {
      return row ? row.declarationList : [];
    },
    printArrangement(data) {
      console.log("打印传进来的数据", data);
      if (!data) {
        return;
      }

      this.$set(this, "printArrangeDetail", data);
      this.printArrageVisible = true;
    },
    doPrintArrangement() {
      // 真的要打印安排了
      // window.frames["print_frame"].document.body.innerHTML =  document.getElementById('printContent').innerHTML;
      // window.frames["print_frame"].window.focus();
      // window.frames["print_frame"].window.print();

      try {
        let selector = ".print-table-wrapper";
        // let selector = '.print-table';
        let container = $(selector);
        // 如果样式是写在css文件里，那么打印的时候就带不上。如果是写成style，那能带上
        // 可以把css单独放服务器上一份，然后写完整地址，就可以加载进css文件了。
        container.printArea();
        // container.printThis();
        // container.print();
      } catch (error) {
        console.log(error);
      }
    },

    findChargePeople(data) {
      // 这个item是个议题，一个议题可以对应好几个负责人，要去feedbacklist里去遍历找出来对应的负责人
      console.log("find people", data);
      let res = [];
      let feedbackList = this.detailData.feedbackList;
      for (let i = 0; i < feedbackList.length; i++) {
        let item = feedbackList[i];
        let _list = item.feedbackList || [];
        for (let j = 0; j < _list.length; j++) {
          if (_list[j].declarationId == data.id) {
            //找到一条的数据，但不一定此时就有负责人的数据，别太高兴
            if (_list[j].reportUserName) {
              res.push(_list[j].reportUserName);
            }
          }
        }
      }

      console.log("找负责人，议题id " + data.id + "  结果是：" + res);
      if (res.length > 0) {
        return res.join("、");
      }
      return "";
    },
    cellClassHandler({ row, column, rowIndex, columnIndex }) {
      // if (columnIndex == 3) {
      //   // 议题
      //   return "no-padding-column";
      // }
      if (columnIndex == 2) {
        return "white-space-pre-line";
      }
      return "";
    },
    arrangeCellClassHandler({ row, column, rowIndex, columnIndex }) {
      // 会议安排的table里列的类名设置
      // if (columnIndex == 3) {
      //   // 议题
      //   return "no-padding-column";
      // }
      return "";
    },
    cellClassHandler2({ row, column, rowIndex, columnIndex }) {
      // if (columnIndex == 3) {
      //   // 议题
      //   return "no-padding-column";
      // }
      // if (columnIndex == 4) {
      //   // 会议纪要
      //   return "no-padding-column";
      // }
      // if (columnIndex == 5) {
      //   // 会议反馈
      //   return "no-padding-column";
      // }
      // if (columnIndex == 6) {
      //   // 负责人
      //   return "no-padding-column";
      // }
      return "";
    },
    printFile() {
      try {
        this.myEditor.execCommand("print");
      } catch (error) {
        console.log(error);
      }
    },
    stopMeetingFeedback() {
      console.log("----------[[[[[   stopMeetingFeedback");
      this.$confirm("您确定已经保存过会议反馈了吗？", "提示", {
        confirmButtonText: "确定",
        type: "warning",
      })
        .then(() => {
          this.inUpMeetingFeedback = false;
        })
        .catch(() => {});
    },
    saveMeetingFeedback(item) {
      // 点击保存会议反馈
      this.$confirm("您确定要保存会议反馈吗？", "提示", {
        confirmButtonText: "确定",
        type: "warning",
      })
        .then(() => {
          console.log("<<>>>", item);
          let params = {
            id: item.id,
            conferenceId: item.conferenceId
              ? item.conferenceId
              : this.detailData.id, // 后台回来的数据里面可能没有这个conferenceId
            declarationId: item.declarationId,
            feedback: item.feedbackLocal,
          };
          return postConferenceFeedback(params);
        })
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            this.$alert(Constants.Upload_OK_Msg, "提示");
            this.inUpMeetingFeedback = false;
            this.$nextTick(() => {
              this.getDetail();
            });
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    selectDialogClose(data) {
      this.selectDialogVisible = false;
      let { dataKey } = data;
      if (this.addHeadPeopleTarget.dataKey == dataKey) {
        // let people = this.addHeadPeopleTarget.headPeople;
        let userList = data.userList || [];
        let people = [];
        userList.forEach((user) => {
          people.push(user);
        });
        this.addHeadPeopleTarget.headPeople = people;
        // userList.forEach(user => {
        //   let index = people.findIndex(p => p.id == user.id);
        //   if (index == -1) {
        //     people.push(user);
        //   }
        // });
      } else {
        console.error("选定的提报单跟最后弹框选择好负责人的提报单对不起来了");
      }
    },
    addHeadPeople(declaration) {
      this.addHeadPeopleTarget = declaration;
      let key = Date.now().toString();
      this.$set(this.addHeadPeopleTarget, "dataKey", key);
      this.selectDialogOptions.dataKey = key;
      this.selectDialogVisible = true;
    },
    saveMeetingMinutes() {
      // 填写完会议纪要后，点击上传
      console.log("要上传会议纪要了\n", this.upMeetingMinutesData);
      if (!this.meetingMinutesGeneralSummary) {
        this.$alert("请填写总体纪要", "提示");
        return;
      }
      let list = [];
      let unset = false;
      for (let i = 0; i < this.upMeetingMinutesData.length; i++) {
        let item = this.upMeetingMinutesData[i];
        for (let j = 0; j < item.declarationList.length; j++) {
          let o = item.declarationList[j];
          if (!o.minutes || o.headPeople.length == 0) {
            unset = true;
            break; // break并不会直接跳出多层循环，只是确实能跳过不少次的循环而已
          }
          let vo = {
            id: o.id,
            summary: o.minutes,
            reportUserJson: JSON.stringify(o.headPeople),
          };
          list.push(vo);
        }
      }
      if (unset) {
        this.$alert("请填写议题对应的纪要和负责人", "提示");
        return;
      }

      let params = {
        generalSummary: this.meetingMinutesGeneralSummary,
        id: this.id,
        summaryList: list,
      };

      this.$confirm("会议纪要保存后无法修改，是否确定保存？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        postConferenceSummary(params)
          .then((res) => {
            if (res.code == Constants.Code_OK) {
              this.$alert(Constants.Upload_OK_Msg, "提示");
              this.inUpMeetingMinutes = false;
              this.$nextTick(() => {
                this.getDetail();
              });
            } else {
              this.$alert(res.msg, "提示");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      });
    },
    upMeetingMinutes() {
      this.$confirm(
        "您确定现在上传会议纪要吗？会议纪要只可上传一次！",
        "提示",
        {
          confirmButtonText: "确定",
          type: "warning",
        }
      )
        .then(() => {
          this.inUpMeetingMinutes = true;
          this.inUpMeetingFeedback = false;
          this.meetingMinutesGeneralSummary = ""; //每次上传都是新的
          let array = cloneDeep(this.detailData.agendaList); //从议程的数据里深拷贝一份出来
          array.forEach((agenda) => {
            agenda.declarationList.forEach((declaration) => {
              declaration.minutes = ""; // 单条提报单对应的会议纪要
              declaration.headPeople = []; // 负责人
            });
          });
          this.upMeetingMinutesData = array;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    upMeetingFeedback() {
      console.log("this.feedbackData", this.feedbackData);

      let myId = sessionStorage.getItem("currentUserId");
      // console.log("--", this.writeUserIdSet, myId);
      // let index = this.writeUserIdSet.findIndex(userId => userId == myId);
      // if (index == -1) {
      //   this.$alert("您当前没有权限上传会议反馈");
      //   return;
      // }

      // writeUserIdSet 里有所有有权限上传的人的id
      let can = true;
      let feedbackList = this.detailData.feedbackList;
      let count = 0;
      for (let i = 0; i < feedbackList.length; i++) {
        let item = feedbackList[i];
        if (item.feedbackList.length == 0) {
          // 这就判定此时还没有上传完会议纪要，那就不能填会议反馈
          can = false;
          this.$alert("还未开启上传会议反馈", "提示");
          return;
        }
        for (let j = 0; j < item.feedbackList.length; j++) {
          let comp = item.feedbackList[j];
          // if (comp.reportUserId == this.userId && comp.feedbackStatus == 0) {
          //   // 是我要上传反馈的，但我还没有反馈
          //   count += 1;
          // }
          // console.group('---');
          // console.log(comp);
          // console.log(comp.writeUserIdSet);
          // if(comp.writeUserIdSet) {
          //   console.log('---',comp.writeUserIdSet.indexOf(this.userId));
          // }
          // console.log(comp.feedbackStatus);
          // console.groupEnd()
          if (
            comp.writeUserIdSet &&
            comp.writeUserIdSet.indexOf(this.userId) != -1 &&
            comp.feedbackStatus == 0
          ) {
            count += 1;
          }
        }
      }
      if (count == 0) {
        // 并没有需要我上传的反馈
        this.$alert("需要议题负责人进行反馈！", "提示");
        return;
      }

      this.$confirm("您确定现在上传会议反馈吗？", "提示", {
        confirmButtonText: "确定",
        type: "warning",
      })
        .then(() => {
          this.inUpMeetingFeedback = true;
          this.inUpMeetingMinutes = false;
          this.feedbackDataLocal = cloneDeep(this.feedbackData);
          console.log("------>>>>> feedbackDataLocal", this.feedbackDataLocal);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleTime(time) {
      return formatTimeStr(time);
    },
    handleJoinWork(item, type) {
      if (type == 1) {
        const { joinWorkJson } = item;
        return JSON.parse(joinWorkJson);
      } else {
        const { ccJoinWorkJson } = item;
        if (ccJoinWorkJson) {
          return JSON.parse(ccJoinWorkJson);
        } else {
          return [{ displayName: "" }];
        }
      }
    },
    createFile(row) {
      // 生成汇报材料
      // row是议程数据，从议程分出提报单来，然后去获取提报单的详情数据，才能拿到提报单的标题和主要内容还有附件，生成之后放入content
      // console.log("row", row);
      // let { typeMap } = row;
      // let types = [];
      // for (let key in typeMap) {
      //   types.push(typeMap[key]);
      // }
      // let h1 = types.join("暨"); // 标题
      let h1 = "青岛路桥建设集团有限公司";
      let { declarationList } = row;
      let promiseList = declarationList.map((item) => {
        return new Promise((resolve, reject) => {
          getDeclarationDetail({ id: item.id }).then((res) => {
            if (res.code == Constants.Code_OK) {
              resolve(res.data);
            } else {
              reject(new Error(res.msg));
            }
          });
        });
      });
      Promise.all(promiseList)
        .then((result) => {
          let main = [];
          let files = [];
          for (let i = 0; i < result.length; i++) {
            let item = result[i];
            let { title, declarationItemsVOs, content } = item;
            let titleStr = `<h2 style="text-align: center;">${title}</h2>`;
            let contentStr = `<p>${content}</p>`;
            let part = `${titleStr}<p><br></p>${contentStr}<p><br></p>`;
            main.push(part);

            if (declarationItemsVOs) {
              declarationItemsVOs.forEach((o) => {
                files.push(`<li><p>${o.name}</p></li>`);
              });
            }
          }

          let head = `<h4 style="text-align: right;margin-right: 50px;">会后收回</h4>`;
          head += `<h1 style="text-align: center;"><span style="color: rgb(240, 102, 102);">${h1}会议材料</span></h1>`;
          head += `<h4 style="text-align: right;margin-right: 200px;">签批：</h4>`;
          head += `<h4 style="text-align: right;margin-right: 200px;">审核：</h4>`;
          head += `<hr/>`;

          let body = main.join("");
          let footer = files.join("");
          if (footer) {
            footer =
              "<h3>附件:</h3><p><br></p>" +
              '<ol class=" list-paddingleft-2" style="list-style-type: decimal;">' +
              footer +
              "</ol>";
          }
          let content = `${head}<p><br></p>${body}<p><br></p>${footer}<p><br></p>`;
          this.textDialogVisible = true;
          this.$nextTick(() => {
            if (!this.myEditor) {
              this.myEditor = window.UE.getEditor(
                this.editorId,
                this.editorConfig
              );
            }
            const editor = this.myEditor;
            editor.ready(function () {
              editor.setContent(content);
            });
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleReporter(row) {
      //处理汇报人
      let result = new Set();
      if (row && row.declarationList) {
        row.declarationList.forEach((vo) => {
          result.add(vo.reportUserName);
        });
      }
      result = Array.from(result);
      return result;
    },
    handleCheckWork(row) {
      // 处理参会部门
      let result = new Set();
      if (row && row.declarationList) {
        row.declarationList.forEach((vo) => {
          const { checkWorkJson } = vo;
          let checkWorkList = JSON.parse(checkWorkJson);
          checkWorkList.forEach((work) => {
            result.add(work.name);
          });
        });
      }
      result = Array.from(result);
      return result;
    },
    handleTypeMap(row) {
      const { typeMap } = row;
      let result = [];
      for (let key in typeMap) {
        result.push(typeMap[key]);
      }
      return result;
    },
    handleAllTypeMap(row) {
      let result = [];
      this.typeList.forEach((t) => {
        result.push(t.value);
      });
      return result;
    },
    initMeetingTypeList() {
      getOtherConferenceTypeList()
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            let list = res.data || [];
            let filterList = list.filter((item) => item.label != "zthy");
            this.typeList = filterList;
            console.log("类型", this.typeList);
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {});
    },
    onActive(menuCode) {
      console.log("menucode 222", menuCode);
      this.userId = parseInt(sessionStorage.getItem("currentUserId"));
      let params = this.tabRouteParam || {};
      if (params.id) {
        this.id = params.id;
      }
      console.log("detail id", this.id);
      this.initMeetingTypeList();
      if (this.id) {
        this.getDetail().catch(() => {});
      } else {
        this.$alert(Constants.Err_Msg, "提示");
      }
      this.activeName = "first";
    },
    getDetail() {
      return getConferenceDetail({ conferenceId: this.id })
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            let data = res.data;
            this.detailData = data;
            this.writeUserIdSet = data.writeUserIdSet || [];
            this.checkGeneralSummaryReadonly();
            this.scheduleData = data.agendaList || [];
            let __planList = data.planList || [];
            // 做次排序，按照创建时的排序规则，保持前后一致，看起来好看
            if (__planList.length > 0) {
              __planList.sort((a, b) => {
                return a.type.localeCompare(b.type);
              });
            }
            this.arrangeData = __planList;
            console.log("---arrangeData", this.arrangeData);
            let originFeedbackList = data.feedbackList || [];
            // let originFeedbackList = this.testData;
            let formatList = [];
            // 这里反馈的展示只针对负责人都填写好之后的情况。没填或者没填完都数据不全，这有个o用啊。
            for (let i = 0; i < originFeedbackList.length; i++) {
              const { id, title, feedbackList } = originFeedbackList[i];
              let vo = {
                id,
                title,
              };
              formatList.push(vo); // vo是一个议程的数据
              let map = {};
              for (let j = 0; j < feedbackList.length; j++) {
                // 遍历议程下的每一条反馈，按照议题来合并
                feedbackList[j].feedbackLocal = "";
                let declarationId = feedbackList[j].declarationId;
                if (map[declarationId]) {
                  map[declarationId].list.push(feedbackList[j]);
                } else {
                  map[declarationId] = {
                    title: feedbackList[j].title, // 一个议题下，只会有一个标题和一个纪要
                    summary: feedbackList[j].summary,
                    list: [feedbackList[j]], // 但是一个议题下，可能会多个反馈，这要看选了几个负责人
                  };
                }
              }

              let temp = [];
              for (let key in map) {
                temp.push(map[key]);
              }

              vo.list = temp; // 议程下的议题
            }
            this.feedbackData = formatList;
            console.log("详情数据\n", this.detailData);
            console.log("整理后的反馈数据\n", this.feedbackData);
            console.log("议程数据\n", this.scheduleData);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getStatusLabel() {
      if (!this.detailData) {
        return "未开始";
      }
      const { status } = this.detailData;
      if (status == 0 || status == 1 || status == 2) {
        return "未开始";
      } else if (status == 3 || status == 4) {
        return "进行中";
      } else if (status == 5) {
        return "已结束";
      } else {
        return "";
      }
    },
    checkGeneralSummaryReadonly() {
      // 如果纪要完成或者会议结束了，那肯定不能编辑
      // 如果已经填过纪要了，那也不让编辑了，暂时是不做修改功能的
      if (!this.detailData) {
        this.generalSummaryReadonly = true;
      } else if (this.detailData.status == 4 || this.detailData.status == 5) {
        this.generalSummaryReadonly = true;
      } else if (this.detailData.generalSummary) {
        this.generalSummaryReadonly = true;
      } else {
        this.generalSummaryReadonly = false;
      }
    },
    cancelJiyao() {
      this.upMeetingMinutesData = [];
      this.inUpMeetingMinutes = false;
      this.inUpMeetingFeedback = false;
    },
    cancalFankui() {
      this.inUpMeetingFeedback = false;
      this.inUpMeetingMinutes = false;
      this.feedbackDataLocal = [];
    },
  },
  computed: {
    minutesVisible: function () {
      if (!this.detailData) {
        return false;
      }
      if (
        this.detailData &&
        (this.detailData.status == 3 ||
          this.detailData.status == 4 ||
          this.detailData.status == 5)
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/commonLayout.scss";
.general-meeting-detail {
  background-color: white;
  padding: 20px;
}
.el-tab-pane {
  margin-top: 20px;
}

/deep/ .el-tabs__item {
  padding: 0 20px !important;
}
/deep/ .el-tabs__header {
  padding-right: 0px !important;
}

/deep/ .el-form-item__content {
  display: flex;

  .el-input {
    flex: 1;
  }

  .el-button {
    margin-left: 10px;
    height: fit-content;
  }

  .tag-wrapper {
    border: 1px solid #dcdfe6;
    padding: 0 5px;
  }
}

.reporter-item {
  margin-right: 5px;
  margin-bottom: 5px;
}

.arrange-box {
  padding-bottom: 50px;
}

.el-form + .el-table {
  margin-top: 20px;
}

.outter-box + .outter-box {
  border-top: 1px solid #dcdfe6;
}

.inner-box + .inner-box {
  border-top: 1px solid #dcdfe6;
}

.quilleditor {
  margin: 0 auto;
}

// /deep/.no-padding-column {
//   .cell {
//     padding: 0 !important;
//   }
// }

// /deep/.white-space-pre-line {
//   .cell {
//     white-space: pre-line;
//   }
// }

.topic-item + .topic-item {
  border-top: 1px solid #dcdfe6;
}

.topic-item {
  padding-top: 6px;
  padding-bottom: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/deep/.el-input-group__append {
  background: #069dbc;
  color: white;
  cursor: pointer;
}
</style>
